<div
  [ngClass]="displayOnTopBar ? 'conversation-title-top-bar' : 'conversation-title-preview'"
  [ngStyle]="{ color: isInternalInfoDeleted || conversationClosed ? 'lightgrey' : 'black' }"
  title="{{ title$ | async | translate }}"
>
  {{ title$ | async | translate }}
</div>
